export default __webpack_public_path__ + "static/media/back.df74c568.svg";